import { BrowserMetaData } from "../two-fa/browser-metadata";

export class LoginModel {
  UserEmail!: string;
  Password!: string;
  RecaptchaToken!: string;
  IsCloud!: boolean;
  BrowserMetaData!: BrowserMetaData;
}

export class PwdValidatorRes {
  IsPasswordValid!: boolean;
  ValidationMessage: string[];
}

export class PwdValidatorParam {
  Password!: string;
  OrgId?: number;
}
